<template>
    <div>
    <div class="container mt-4 mb-4">
        <!-- <atras-component></atras-component> -->
        <boton-atras :nombre_ruta="'estatal'"></boton-atras>
        <div class="row">
            <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                <h6 class="subtitulo mb-2">Cursos y talleres</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>
                <!-- Cursos 2026 -->
                <h4 class="subtitulo2 mt-5">Curso de Capacitación 2026</h4> 
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Cursos/2026/CALENDARIO-INDETEC.xlsx'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Curso de Capacitación INDETEC 2026-calendario</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                <!-- Cursos 2019 -->
                <h4 class="subtitulo2 mt-5">Curso de Capacitación 2019</h4> 
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Cursos/2019/CALENDARIO.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5>Curso - Taller: “Capacitación en materia de Armonización Contable en los términos de las leyes respectivas aplicables” </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                <!-- Cursos 2018 -->
               <h4 class="subtitulo2 mt-5">Curso de Capacitación 2018</h4> 
               <h5 class="mt-4" style="font-size:1rem;">Calendario del Curso de Armonización Contable, Ley de Disciplina Financiera y PbR-SED</h5>
               <h5 class="mt-2" style="font-size:0.9rem;">Cada organismo público debe participar en los tres cursos que se listan, en el día y horario indicados:</h5>             
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Cursos/2018/LGCG-y-LDF.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Obligaciones de la Ley de Disciplina Financiera y los formatos respectivos y Obligaciones de la Ley General de Contabilidad Gubernamental y las Normas del CONAC. </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                 <a :href="urlServe+'marco-juridico/Estatal/informacion/Cursos/2018/PbR-SED.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Presupuesto basado en Resultados y Sistema de Evaluación del Desempeño </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <h5 class="mt-4" style="font-size:1rem;">Presentaciones</h5>


                <a :href="urlServe+'marco-juridico/Estatal/informacion/Cursos/2018/P-LDF.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley de Disciplina Financiera y los Formatos respectivos </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Cursos/2018/P-LGCG.pdf'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley General de Contabilidad Gubernamental y las Normas del CONAC </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                <a :href="urlServe+'marco-juridico/Estatal/informacion/Cursos/2018/P-PbR-SED.pptx'" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Presupuesto basado en Resultados y Sistema de Evaluación del Desempeño </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
               
            
                
                

               

               
               
                
            </div>
            
            <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                <div class="row margenes img_fija">
                    <div class="sec_imagen"> 
                        <img src="@/assets/imagenes/cursos_talleres.jpg" alt="">  
                    </div>
                </div>
                <!--  -->
                <!--  -->               
                
            </div>
        </div>
        <div class="text-aviso my-5">
                <h5> <span class="resaltado-vino">AVISO:</span> El Curso de PbR 2018 programado para el día Jueves 23 de Agosto de 2018, se reprograma para el día Miércoles 29 de Agosto de 15:00 a 21:00 horas, en el Centro Universitario de Información Documental (CUID); de la escuela de música de la UNICACH.Dudas favor de comunicarse a la extensión 65193.</h5>
        </div>
    </div>

    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        atrasComponent,
        botonAtras
    }
}
</script>

<style scoped>
    .card-header { background-color: #fff; }
    .btn-link{ color: #474444; }
    .btn:focus { box-shadow: none; }
    .btn-link:hover { text-decoration: none; }

    li{ 
    list-style:none;
    margin-bottom: 1rem;
    border-bottom: 1px dotted rgb(189, 182, 182);
    padding: .2rem;
    padding-left: 0 !important;
    font-size: 14px;
}
li a:hover{ color: #560f2c !important; text-decoration: none; }



    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    /* 
    lo cambie a estilos.css
    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    } */
    /* 
    
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    } */
    .title_document h5{
        font-size: 0.9rem;
        font-weight: 400;
        /* line-height: 20px; */
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }

    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }
    .card-width{ width: 90%; }
    
    /* select */
    .form-control-lg {
        font-size: 1rem;
        border-radius: .4rem;
    }

    .tab-select{
        position: sticky !important;
        top: 15% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>